import { html, render } from "lit-html";
//import { styleMap } from "lit-html/directives/style-map.js";
import { Input } from "./input";
import Glyphs from "../glyphs";

class LookDialog {
  constructor() {
    this.overlay = document.querySelector(".overlay");
    this.dialog = document.querySelector(".dialog");
    this.isDirty = true;
  }

  activate(context) {
    this.overlay.classList.add("is-visible");
    this.dialog.classList.add("is-visible");
    this.dialog.classList.add("is-alert");
    render(this.getDialogTemplate(context), this.dialog);
  }

  deactivate(context) {
    this.overlay.classList.remove("is-visible");
    this.dialog.classList.remove("is-visible");
    this.dialog.classList.remove("is-alert");
  }

  handleInput(key) {
    switch (key) {
      case "q":
      case "Enter":
      case " ":
        document.dispatchEvent(new CustomEvent("ui.transition", {
          detail: {
            command: "CloseDialog",
          }
        }));
      break;
    }
    return false;
  }

  getDialogTemplate(context) {
    const label = context.name
      .replace(/[0-9]/g, "")
      .replace(/([a-z])([A-Z])/g, "$1 $2");

    return html`
      <h2>${label}</h2>
      <p>${context.description}</p>
    `;
  }

  render(stage) {
    return;
  }
}

export default LookDialog;
